import React from 'react';
import ReactSelectAsync from '../../selects/react-select-async';
import './busq-especif.css';

const FieldBusqEspecifica = ({ input, label, icono, textoBoton, loadOptions, getItemEspecifico, func_OnFocus }) => (    
  <div>
    <label className='label-control'>{label}</label>
    <div className='input-group'>
      < ReactSelectAsync {...input} value={input.value} func_onChange={(value) => input.onChange(value)} func_onBlur={() => input.onBlur(input.value)}
        func_loadOptions={loadOptions} func_OnFocus={func_OnFocus}
      />
      <span className='input-group-addon addon-busq-especif'><button type="button" className='btn btn-default medida-button-busq-especif' onClick={getItemEspecifico}><i className={icono}></i>{" " + textoBoton}</button></span>
    </div>
  </div>
)
export default FieldBusqEspecifica